module.exports = __webpack_public_path__ + "static/img/fish24.db80b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish24.png
// module id = 5A0n
// module chunks = 0